import React, {useEffect, useState} from 'react';
import ToggleOffIcon from '../../SVG/ToggleOffIcon';
import Pencil from '../../SVG/Pencil';
import {useLocation} from 'react-router-dom';
import Input from '../Input';
import {
  useDeleteUserMutation,
  useGetAgencyQuery,
  useLazyGetChosenUserQuery,
  useLoginAsUserMutation,
  useUpdatePasswordMutation,
  useUpdateUserMutation,
  useUpdateUserSsoIgnoreMutation,
} from '../../store/builder/inspections.api';
import {useDispatch, useSelector} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import {toast} from 'react-toastify';
import Select from 'react-select';
import {validationEmail} from '../../global/validate';
import {useErrorHandler} from '../../global/ErrorsHandler';
import UserIcon from '../../SVG/UserIcon';
import LockIcon from '../../SVG/LockIcon';
import useLoader from '../../global/UseLoadingHandler';
import Settings from '../../SVG/Settings';
import UpdateRole from './Modals/UpdateRole';
import GeneralModal from '../GeneralModal/GeneralModal';
import UpdateRegion from './Modals/UpdateRegion';
import {copyText} from "../../global/utils";
import Copy from "../../SVG/Copy";
import SwitchIcon from '../../SVG/SwitchIcon';
import UpdateUser from './Modals/UpdateUser';
import {useTranslation} from '../../hooks/useTranslation';
import moment from 'moment';

const formatUserActivityTimestamp = value => {
  if (!value) {
    return '---';
  }
  const m = moment(value);
  return m.isValid() ? m.format('MM/DD/YY h:mm A') : '---';
};

export default function ManagementRow({
  user,
  userRolesData,
  userAgencyData,
  indexElem,
  lengthArray,
  filteredData,
  setFilteredData,
  setCurrentUser,
  currentUser,
  readOnly = false,
  setUserList,
  trigerGetUsers,
  setTrigerGetUsers,
  getUsers,
  includeUserActivityColumns = false,
  statusFilter = 'active',
}) {
  const {t} = useTranslation();
  const [showIgnoreSsoModal, setShowIgnoreSsoModal] = useState(false);
  const [loginAsModal, setLoginAsModal] = useState(false);
  const [settingsStatus, setSettingsStatus] = useState(false);
  const [confirmStatus, setConfirmStatus] = useState(false);
  const [setRegion, setSetRegion] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editPasswordModal, setEditPasswordModal] = useState(false);
  const [userDetailsModal, setUserDetailsModal] = useState(false);
  const [updateRoleModal, setUpdateRoleModal] = useState(false);
  const [userEditData, setUserEditData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    initials: '',
    ein: '',
    // confirm_password: "",
    role_ids: [],
    agency_ids: [],
    notify_corrective_actions: false,
    notify_inspections: false,
    notify_equipment: false,
    notify_service_requests: false,
    api_access_only: false,
    ignore_sso_role: false,
    is_sso_auth: false,
  });
  const [passwordData, setPasswordData] = useState({
    password: '',
    confirm_password: '',
  });
  const [chosenRoles, setChosenRoles] = useState({});
  const [chosenAgency, setChosenAgency] = useState({});
  const [chosenLocales, setChosenLocales] = useState([]);
  const [lastElem, setLastElem] = useState(false);

  const [dataErrors, setDataErrors] = useState({
    firstNameError: false,
    lastNameError: false,
    emailError: false,
    einError: false,
    rolesError: false,
    agencyError: false,
  });
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);


  const enableUserEdit = () => {
    if (userInfo.is_sso_auth) {
    return null;
  }

  if (user.is_sso_auth) {
    return null;
  }

  const hideUserForAdmin =
    userInfo.is_admin &&
    (user.role_code === 'global' ||
      user.role_code === 'admin' ||
      user.role_code === 'corporate' ||
      user.role_code === 'regional_corporate');

  if (hideUserForAdmin) {
    return null;
  }

  const hideUserForCorporate =
    userInfo.is_corporate &&
    (user.role_code === 'global' || user.role_code === 'corporate');

  if (hideUserForCorporate) {
    return null;
  }

  const hideUserForRegionalCorporate =
    userInfo.is_regional_corporate &&
    (user.role_code === 'global' ||
      user.role_code === 'corporate' ||
      user.role_code === 'regional_corporate');

  if (hideUserForRegionalCorporate) {
    return null;
  }
    return true;
  }

  const location = useLocation();
  const dispatch = useDispatch();

  const [
    deleteUser,
    {
      data: deleteUserData,
      isSuccess: deleteUserIsSuccess,
      isLoading: deleteUserIsLoading,
      isError: deleteUserIsError,
      error: deleteUserError,
    },
  ] = useDeleteUserMutation();

  const [
    getUser,
    {
      data: chosenUserData,
      isSuccess: chosenUserIsSuccess,
      isLoading: chosenUserIsLoading,
      isError: chosenUserIsError,
      error: chosenUserError,
    },
  ] = useLazyGetChosenUserQuery();

  const {
    data: agencyData,
    error: agencyError,
    isLoading: agencyIsLoading,
    isSuccess: agencyIsSuccess,
  } = useGetAgencyQuery();

  const [
    updateUser,
    {
      data: updateUserData,
      isSuccess: updateUserIsSuccess,
      isLoading: updateUserIsLoading,
      isError: updateUserIsError,
      error: updateUserError,
    },
  ] = useUpdateUserMutation();

  const [updateUserSsoIgnore, {isLoading: updateUserSsoIgnoreIsLoading}] =
    useUpdateUserSsoIgnoreMutation();

  const [loginAsUser, {isLoading: loginAsUserIsLoading}] =
    useLoginAsUserMutation();

  const [
    updatePassword,
    {
      data: updatePasswordData,
      isSuccess: updatePasswordIsSuccess,
      isLoading: updatePasswordIsLoading,
      isError: updatePasswordIsError,
      error: updatePasswordError,
    },
  ] = useUpdatePasswordMutation();

  const [errorHandler, setErrorHandler] = useErrorHandler([
    updateUserError,
    agencyError,
    chosenUserError,
    deleteUserError,
  ]);

  useLoader([
    deleteUserIsLoading,
    chosenUserIsLoading,
    agencyIsLoading,
    updateUserIsLoading,
    updatePasswordIsLoading,
    updateUserSsoIgnoreIsLoading,
    loginAsUserIsLoading,
  ]);

  useEffect(() => {
    if (editModal || confirmStatus || loginAsModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [editModal, confirmStatus, loginAsModal]);

  useEffect(() => {
    if (deleteUserIsSuccess) {
      dispatch(setLoader(false));
      toast.success(t('managementRow.messages.updateSuccess'));
      setConfirmStatus(false);
    }
    if (updateUserIsSuccess) {
      dispatch(setLoader(false));
      toast.success(t('managementRow.messages.updateSuccess'));
      setEditModal(false);
    }
  }, [deleteUserIsSuccess, updateUserIsSuccess]);

  useEffect(() => {
    if (chosenUserIsSuccess) {
      setChosenRoles(() => {
        const role = userRolesData?.find(role => role.id === chosenUserData?.data?.role?.id);

        return {
          value: role?.id,
          label: role?.name,
        };
      });
      setChosenAgency({
        value: chosenUserData?.data?.agency?.id,
        label: chosenUserData?.data?.agency?.title,
      });

      // Initialize locales if user has translator_locales data
      if (chosenUserData?.data?.translator_locales && chosenUserData?.data?.translator_locales?.length > 0) {
        setChosenLocales(chosenUserData?.data?.translator_locales?.map(locale => ({
          value: locale.id,
          label: <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
            <img width={20} height={20} src={locale.url} alt={locale.name} />
            {locale.name}
          </div>,
        })));
      } else {
        setChosenLocales([]);
      }

      setUserEditData(old => ({
        ...old,
        first_name: chosenUserData?.data?.first_name,
        last_name: chosenUserData?.data?.last_name,
        email: chosenUserData?.data?.email,
        ein: chosenUserData?.data?.ein,
        initials: chosenUserData?.data?.initials,
        notify_corrective_actions:
          chosenUserData?.data?.notify_corrective_actions,
        notify_inspections: chosenUserData?.data?.notify_inspections,
        notify_equipment: chosenUserData?.data?.notify_equipment,
        notify_service_requests: chosenUserData?.data?.notify_service_requests,
        api_access_only: !!chosenUserData?.data?.api_access_only,
        ignore_sso_role: !!chosenUserData?.data?.ignore_sso_role,
        is_sso_auth: !!chosenUserData?.data?.is_sso_auth,
      }));
    }
  }, [chosenUserData, agencyData]);

  useEffect(() => {
    if (dataErrors.firstNameError) {
      toast.error(t('managementRow.messages.enterCorrectFirstName'));
    }
    if (dataErrors.lastNameError) {
      toast.error(t('managementRow.messages.enterCorrectLastName'));
    }
    if (dataErrors.emailError) {
      toast.error(t('managementRow.messages.enterCorrectEmail'));
    }
    if (dataErrors.ein) {
      toast.error(t('managementRow.messages.enterEin'));
    }
    // if (dataErrors.passwordError) {
    //   toast.error("Please enter correct password and confirm password");
    // }
    if (dataErrors.rolesError) {
      toast.error(t('userManagement.messages.chooseAnyRole'));
    }
    if (dataErrors.agencyError) {
      toast.error(t('userManagement.messages.chooseAnyFbo'));
    }
  }, [dataErrors]);

  const handleDropdownToggle = id => {
    setUserList(old => {
      let updatedList = [...old];
      updatedList?.map(el => {
        if (el.id === id) {
          el.action_status = !el.action_status;
        } else {
          el.action_status = false;
        }
        return el;
      });
      return updatedList;
    });
  };

  const validateEdit = () => {
    if (!userEditData?.first_name || userEditData?.first_name?.length < 3) {
      setDataErrors(old => ({...old, firstNameError: true}));
    } else {
      setDataErrors(old => ({...old, firstNameError: false}));
    }
    if (!userEditData?.last_name || userEditData?.last_name?.length < 3) {
      setDataErrors(old => ({...old, lastNameError: true}));
    } else {
      setDataErrors(old => ({...old, lastNameError: false}));
    }
    if (!userEditData?.email && !validationEmail(userEditData?.email)) {
      setDataErrors(old => ({...old, emailError: true}));
    } else {
      setDataErrors(old => ({...old, emailError: false}));
    }
    // if (userEditData?.password || userEditData?.confirm_password) {
    //   if (userEditData?.password !== userEditData?.confirm_password) {
    //     setDataErrors((old) => ({ ...old, passwordError: true }));
    //   }
    // } else {
    //   setDataErrors((old) => ({ ...old, passwordError: false }));
    // }
    if (chosenRoles === null) {
      setDataErrors(old => ({...old, rolesError: true}));
    } else {
      setDataErrors(old => ({...old, rolesError: false}));
    }

    if (user?.role_title?.toLowerCase() == 'corporate') {
      if (chosenAgency === null) {
        setDataErrors(old => ({...old, agencyError: true}));
      } else {
        setDataErrors(old => ({...old, agencyError: false}));
      }
    }
  };

  const handleIgnoreClick = () => {
    setShowIgnoreSsoModal(true);
  };

  const confirmIgnoreModal = () => {
    updateUserSsoIgnore({
      id: currentUser?.id,
      body: {
        ignore_sso_role: !currentUser?.ignore_sso_role,
      },
    }).then(data => {
      toast.success(t('managementRow.messages.updateSuccess'));
      getUsers();
      setShowIgnoreSsoModal(false);
    });
  };

  const closeDropdown = () => {
    setUserList(old => {
      let updatedList = [...old];
      updatedList?.map(el => {
        if (el.id === user?.id) {
          el.action_status = false;
        }
        return el;
      });
      return updatedList;
    });
  };

  const tableRowSettings = (itemId) => {
    return (
        <div
            className={`${
                lastElem
                    ? 'management__table-settings_last'
                    : 'management__table-settings'
            }`}
        >
          {userInfo?.is_global  && <div
              className={`blue `}
              onClick={() => {
                copyText(t('actions.copiedNDXID'), itemId);
                closeDropdown();
              }}
          >
            <Copy color={'#999999'}/>
            NDX ID - {itemId}
          </div>}
          {userInfo?.is_global && statusFilter === 'active' && (
            <div
              className='management__table-edit'
              onClick={() => {
                setLoginAsModal(true);
                closeDropdown();
              }}
            >
              <SwitchIcon color={'#999999'}/>
              <span>Login as</span>
            </div>
          )}
          <div
              className='management__table-edit'
              onClick={() => {
                setUserDetailsModal(true);
                closeDropdown();
              }}
          >
            <UserIcon color={'#999999'}/>
            <span>{t('managementRow.modals.userDetails')}</span>
          </div>

          <EditButton
              myUser={userInfo}
              changeUser={user}
              setEditModal={setEditModal}
              getUser={getUser}
              closeDropdown={closeDropdown}
          />

          <UpdateRoleButton
              setUpdateRoleModal={setUpdateRoleModal}
              myUser={userInfo}
              changeUser={user}
              setCurrentUser={setCurrentUser}
              closeDropdown={closeDropdown}
          />

          <UpdatePasswordButton
              setEditPasswordModal={setEditPasswordModal}
              myUser={userInfo}
              changeUser={user}
              closeDropdown={closeDropdown}
          />
          <SetUserRegionButton
              setSetRegion={setSetRegion}
              myUser={userInfo}
              changeUser={user}
              closeDropdown={closeDropdown}
          />
          <DeleteUserButton
              setConfirmStatus={setConfirmStatus}
              myUser={userInfo}
              changeUser={user}
              closeDropdown={closeDropdown}
              statusFilter={statusFilter}
          />
        </div>
    );
  };

  const handleLoginAs = () => {
    loginAsUser(user.id)
      .unwrap()
      .then(data => {
        localStorage.clear();
        localStorage.setItem('ndx_user_token', data?.access_token);
        window.location.href = '/dashboard';
      })
      .catch(err => {
        toast.error(err?.data?.message || 'Failed to login as user');
        setLoginAsModal(false);
      });
  };

  const loginAsConfirmModal = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>Login as User</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setLoginAsModal(false)}
            />
          </div>
          <div className='modal__content-body delete'>
            <p>Are you sure you want to login as {user.name}?</p>
          </div>
          <div className='modal__content-bottom'>
            <button className='close' onClick={() => setLoginAsModal(false)}>
              {t('managementRow.modals.close')}
            </button>
            <button className='save' onClick={handleLoginAs}>
              Confirm
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </div>
    );
  };

  const confirmModal = () => {
    return (
        <div className='modal'>
          <div className='modal__content'>
            <div className='modal__content-head'>
              <p>{t('managementRow.modals.deactivateUser')}</p>
              <img
                  className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => {
                setConfirmStatus(false);
                setSettingsStatus(false);
              }}
            />
          </div>
          <div className='modal__content-body delete'>
            <p>{t('managementRow.messages.areYouSureYouWantToDeactivateThisUser')}</p>
          </div>
          <div className='modal__content-bottom'>
            <button
              className='close'
              onClick={() => {
                setConfirmStatus(false);
                setSettingsStatus(false);
              }}
            >
              {t('managementRow.modals.close')}
            </button>
            <button className='save' onClick={() => deleteUser(user.id)}>
              {t('managementRow.modals.deactivate')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </div>
    );
  };

  const handleEditChanges = e => {
    if (e.target.type === 'checkbox') {
      setUserEditData(old => ({...old, [e.target.name]: e.target.checked}));
    } else {
      setUserEditData(old => ({...old, [e.target.name]: e.target.value}));
    }
  };
  const handlePasswordChanges = e => {
    setPasswordData(old => ({...old, [e.target.name]: e.target.value}));
  };

  const handleCreateUser = e => {
    e.preventDefault();
    validateEdit();
    if (
      !dataErrors?.nameError &&
      !dataErrors?.lastNameError &&
      // !dataErrors?.emailError &&
      !dataErrors?.rolesError &&
      !dataErrors?.passwordError &&
      !dataErrors?.agencyError
    ) {
      dispatch(setLoader(true));

      let body = {
        id: user.id,
        first_name: userEditData?.first_name,
        last_name: userEditData?.last_name,
        email: userEditData?.email,
        ein: userEditData?.ein,
        initials: userEditData?.initials,
        role_id: chosenRoles?.value,
        agency_id: chosenAgency?.value,
        notify_corrective_actions: userEditData?.notify_corrective_actions,
        notify_inspections: userEditData?.notify_inspections,
        notify_equipment: userEditData?.notify_equipment,
        notify_service_requests: userEditData?.notify_service_requests,
        api_access_only: userEditData?.api_access_only ? 1 : 0,
        ignore_sso_role: userEditData?.ignore_sso_role,
      };

      if (body.role_id === 9 || body.role_id === 8) {
        delete body.agency_id;
      }

      // Handle agency_id for role 10 (locale role)
      if (body.role_id === 10) {
        body.agency_id = null;
        // Add locale data for role 10 (locale role)
        if (chosenLocales && chosenLocales.length > 0) {
          body.locale_ids = chosenLocales.map(locale => locale.value);
        }
      }

      updateUser(body)
        .then(res => {
          dispatch(setLoader(false));
          setTrigerGetUsers(!trigerGetUsers);
        })
        .catch(err => {
          dispatch(setLoader(false));
        });
    }
  };

  const handleChangePassword = e => {
    e.preventDefault();
    if (!passwordData?.password || !passwordData?.confirm_password) {
      toast.error(t('managementRow.messages.enterBothPasswords'));
    } else {
      if (passwordData?.password?.length < 8) {
        toast.error(t('managementRow.messages.passwordMinLength'));
        return;
      }
      if (passwordData?.password === passwordData?.confirm_password) {
        dispatch(setLoader(true));
        updatePassword({
          id: user.id,
          password: passwordData?.password,
          password_confirmation: passwordData?.confirm_password,
        }).unwrap()
          .then(data => {
            setEditPasswordModal(false);
            if (data?.data.message) {
              toast.success(t('managementRow.messages.updateSuccess'));
            }
          })
          .catch(err => {
            toast.error(err?.data?.message);
          })
          .finally(() => {
            dispatch(setLoader(false));
          });
      } else {
        toast.error(t('managementRow.messages.passwordsShouldMatch'));
      }
    }
  };

  const renderEditPasswordModal = () => {
    return (
      <form className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('managementRow.modals.updatePassword')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setEditPasswordModal(false)}
            />
          </div>
          <div className='modal__content-body user'>
            <Input
              id='password'
              name='password'
              placeholder={t('managementRow.labels.password')}
              label={t('managementRow.labels.password')}
              type={'password'}
              minLength={8}
              onChange={handlePasswordChanges}
            />
            <Input
              id='confirm_password'
              name='confirm_password'
              placeholder={t('managementRow.labels.confirmPassword')}
              label={t('managementRow.labels.confirmPassword')}
              type={'password'}
              minLength={8}
              onChange={handlePasswordChanges}
            />
          </div>
          <div className='modal__content-bottom'>
            <button
              className='close'
              onClick={() => setEditPasswordModal(false)}
            >
              {t('managementRow.modals.close')}
            </button>
            <button className='save' onClick={handleChangePassword}>
              {t('managementRow.modals.save')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </form>
    );
  };

  const renderUserDetailsModal = () => {
    return (
      <form className='modal modal-drawer'>
        <div
          className='modal__content modal__content-drawer'
        >
          <div className='modal__content-head'>
            <p>{t('managementRow.modals.userDetails')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setUserDetailsModal(false)}
            />
          </div>
          <div className='modal__content-body user-drawer' style={{height: '700px', overflowY: 'auto'}}>
            <div className='modal__content-body_avatar'>
              <div className='modal__content-body_avatar-image-wrapper'>
                <img src={currentUser?.avatar} alt='avatar' />
              </div>
            </div>
            <Input
              disabled={true}
              id='first_name'
              name='first_name'
              placeholder={t('managementRow.labels.firstName')}
              label={t('managementRow.labels.firstName')}
              type={'text'}
              defaultValue={currentUser?.first_name}
            />
            <Input
              disabled={true}
              id='last_name'
              name='last_name'
              placeholder={t('managementRow.labels.lastName')}
              label={t('managementRow.labels.lastName')}
              type={'text'}
              defaultValue={currentUser?.last_name}
            />
            <Input
              id='ein'
              name='ein'
              placeholder={t('managementRow.labels.ein')}
              label={t('managementRow.labels.ein')}
              type={'text'}
              defaultValue={currentUser?.ein}
              disabled={true}
            />
            <Input
              id='email'
              name='email'
              placeholder={t('managementRow.labels.email')}
              label={t('managementRow.labels.email')}
              type={'email'}
              disabled={true}
              defaultValue={currentUser?.email}
            />
            <Input
              disabled={true}
              id='initials'
              name='initials'
              placeholder={t('managementRow.labels.initials')}
              label={t('managementRow.labels.initials')}
              type={'text'}
              defaultValue={currentUser?.initials}
            />
            <div className='modal__content-body_signature'>
              <img src={currentUser?.signature} alt='signature' />
            </div>
            <Input
              id='user-roles'
              name='user-roles'
              placeholder={t('managementRow.labels.userRoles')}
              label={t('managementRow.labels.userRoles')}
              disabled={true}
              defaultValue={currentUser?.role_title}
            />
          </div>

          <div className='modal__content-bottom'>
            <button
              className='close'
              onClick={() => setUserDetailsModal(false)}
            >
              {t('managementRow.modals.cancel')}
            </button>
            <button
              className={`save ${!enableUserEdit && 'disabled'}`}
              onClick={() => {
                setUserDetailsModal(false);
                setEditModal(true);
                getUser(user?.id);
              }}
              disabled={!enableUserEdit}
            >
              {t('managementRow.modals.editUser')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </form>
    );
  };

  return (
    <>
      {loginAsModal && loginAsConfirmModal()}
      {confirmStatus && confirmModal()}
      {editModal && <UpdateUser
        userEditData={userEditData}
        handleEditChanges={handleEditChanges}
        user={user}
        userRolesData={userRolesData}
        agencyData={agencyData}
        chosenRoles={chosenRoles}
        setChosenRoles={setChosenRoles}
        chosenAgency={chosenAgency}
        setChosenAgency={setChosenAgency}
        setEditModal={setEditModal}
        userInfo={userInfo}
        handleCreateUser={handleCreateUser}
        chosenLocales={chosenLocales}
        setChosenLocales={setChosenLocales}
      />}
      {userDetailsModal && renderUserDetailsModal()}
      {editPasswordModal && renderEditPasswordModal()}
      {updateRoleModal && (
        <UpdateRole
          setUpdateRoleModal={setUpdateRoleModal}
          currentUser={currentUser}
          agencyData={agencyData}
          setTrigerGetUsers={setTrigerGetUsers}
          trigerGetUsers={trigerGetUsers}
          getUsers={getUsers}
          open={updateRoleModal}
        />
      )}
      {setRegion && (
        <UpdateRegion
          setSetRegion={setSetRegion}
          currentUser={currentUser}
          agencyData={agencyData}
          setTrigerGetUsers={setTrigerGetUsers}
          trigerGetUsers={trigerGetUsers}
          getUsers={getUsers}
        />
      )}
      <div
        className={`management__table-row${userInfo?.is_global && statusFilter === 'active' ? ' global' : ''}`}
        onClick={() => setCurrentUser(user)}
        onMouseOver={() => setCurrentUser(user)}
      >
        <div className='management__table-bodyTh avatar'>
          <img src={user.avatar} alt='photo' />
        </div>
        <div className='management__table-bodyTh'>
          <span>{user.name}</span>
        </div>
        <div className='management__table-bodyTh'>
          <span>{user.email}</span>
          <div style={{display: 'flex', gap: 5}}>
            {(user?.ignore_sso_role || user?.is_sso_auth) && (
              <div className={`management__table-bodyTh-status on `}>
                SSO {user?.ignore_sso_role && 'ignore'}
              </div>
            )}
            {user?.region_set_is_pending && (
              <div
                className={`management__table-bodyTh-status `}
                style={{
                  background: '#DA67671F',
                  color: '#DA6767',
                  borderColor: '#DA6767',
                }}
              >
                no regions
              </div>
            )}
          </div>
        </div>
        <div
          style={{wordWrap: 'break-word'}}
          className='management__table-bodyTh'
        >
          <span>{user?.agency_title}</span>
        </div>
        <div
          className='management__table-bodyTh'
          style={{textTransform: 'capitalize'}}
        >
          <p>{user?.role_title}</p>
        </div>
        <div
          className='management__table-bodyTh'
          style={{textTransform: 'capitalize'}}
        >
          <p>{user?.ein || '---'}</p>
        </div>
        <div
          className='management__table-bodyTh'
          style={{textTransform: 'capitalize'}}
        >
          <p>{user?.initials || '---'}</p>
        </div>
        <div
          className='management__table-bodyTh'
          style={{textTransform: 'capitalize'}}
        >
          {user?.signature ? (
            <div className='management__table-bodyTh-signature'>
              <img src={user?.signature} alt='signature' />
            </div>
          ) : (
            <span>{t('managementRow.status.noSignature')}</span>
          )}
        </div>
        {includeUserActivityColumns ? (
          <>
            <div className='management__table-bodyTh management__userActivityCell'>
              <span>{formatUserActivityTimestamp(user?.last_login_at)}</span>
            </div>
            <div className='management__table-bodyTh management__userActivityCell'>
              <span>{formatUserActivityTimestamp(user?.last_mobile_login_at)}</span>
            </div>
            <div className='management__table-bodyTh management__userActivityCell'>
              <span>
                {formatUserActivityTimestamp(
                  statusFilter === 'active' ? user?.first_active_at : user?.deactivated_at,
                )}
              </span>
            </div>
          </>
        ) : null}
        <div className='management__table-bodyTh userSettings'>
          {userInfo?.is_admin && user?.role?.name !== 'global' ? (
            <img
              src='/assets/icons/dots.svg'
              alt='dots'
              className='dots'
              onClick={() => {
                handleDropdownToggle(user?.id);
                if (lengthArray === indexElem + 1) {
                  setLastElem(true);
                } else {
                  setLastElem(false);
                }
              }}
            />
          ) : userInfo?.is_global || userInfo?.is_corporate ? (
            <img
              src='/assets/icons/dots.svg'
              alt='dots'
              onClick={() => {
                handleDropdownToggle(user?.id);
                if (lengthArray === indexElem + 1) {
                  setLastElem(true);
                } else {
                  setLastElem(false);
                }
              }}
            />
          ) : null}
          {user?.action_status && !readOnly && tableRowSettings(user?.id)}
        </div>
      </div>
      <>
        {showIgnoreSsoModal && (
          <GeneralModal
            title={t('managementRow.modals.updateSsoIgnore')}
            onSubmit={confirmIgnoreModal}
            onClose={() => setShowIgnoreSsoModal(false)}
          >
            <div className='modal__content-body'>
              <p className='modal__content-dangerText'>
                Are you sure you want to update SSO ignore?
              </p>
            </div>
          </GeneralModal>
        )}
      </>
    </>
  );
}

export const EditButton = ({myUser, changeUser, setEditModal, getUser, closeDropdown}) => {
  const {t} = useTranslation();
  
  if (myUser.is_sso_auth) {
    return null;
  }

  if (changeUser.is_sso_auth) {
    return null;
  }

  const hideUserForAdmin =
    myUser.is_admin &&
    (changeUser.role_code === 'global' ||
      changeUser.role_code === 'admin' ||
      changeUser.role_code === 'corporate' ||
      changeUser.role_code === 'regional_corporate');

  if (hideUserForAdmin) {
    return null;
  }

  const hideUserForCorporate =
    myUser.is_corporate &&
    (changeUser.role_code === 'global' || changeUser.role_code === 'corporate');

  if (hideUserForCorporate) {
    return null;
  }

  const hideUserForRegionalCorporate =
    myUser.is_regional_corporate &&
    (changeUser.role_code === 'global' ||
      changeUser.role_code === 'corporate' ||
      changeUser.role_code === 'regional_corporate');

  if (hideUserForRegionalCorporate) {
    return null;
  }

  return (
    <div
      className='management__table-edit'
      onClick={() => {
        setEditModal(true);
        getUser(changeUser?.id);
        closeDropdown();
      }}
    >
      <Pencil color={'#999999'} />
      <span>{t('managementRow.actions.editUser')}</span>
    </div>
  );
};

export const UpdateRoleButton = ({myUser, changeUser, setUpdateRoleModal, setCurrentUser, closeDropdown}) => {
  const {t} = useTranslation();
  
  if (changeUser?.is_sso_auth) {
    return null;
  }

  const hideUserForAdmin =
    myUser.is_admin &&
    (changeUser.role_code === 'global' ||
      changeUser.role_code === 'admin' ||
      changeUser.role_code === 'corporate' ||
      changeUser.role_code === 'regional_corporate');

  if (hideUserForAdmin) {
    return null;
  }

  const hideUserForCorporate =
    myUser.is_corporate &&
    (changeUser.role_code === 'global' || changeUser.role_code === 'corporate');

  if (hideUserForCorporate) {
    return null;
  }

  const hideUserForRegionalCorporate =
    myUser.is_regional_corporate &&
    (changeUser.role_code === 'global' ||
      changeUser.role_code === 'corporate' ||
      changeUser.role_code === 'regional_corporate');

  if (hideUserForRegionalCorporate) {
    return null;
  }

  return (
    <div
      className='management__table-edit'
      onClick={() => {
        setUpdateRoleModal(true);
        closeDropdown();
      }}
      onMouseOver={() => setCurrentUser(changeUser)}
    >
      <Settings color={'#999999'} />
      <span>{t('managementRow.actions.updateRole')}</span>
    </div>
  );
};

export const UpdatePasswordButton = ({
  myUser,
  changeUser,
  setEditPasswordModal,
  closeDropdown,
}) => {
  const {t} = useTranslation();
  
  if (changeUser?.is_sso_auth) {
    return null;
  }

  if (myUser?.is_sso_auth) {
    return null;
  }

  return (
    <div
      className='management__table-edit'
      onClick={() => {
        setEditPasswordModal(true);
        closeDropdown();
      }}
    >
      <LockIcon color={'#999999'} />
      <span>{t('managementRow.actions.updatePassword')}</span>
    </div>
  );
};

export const DeleteUserButton = ({myUser, changeUser, setConfirmStatus, closeDropdown, statusFilter}) => {
  const {t} = useTranslation();

  if (statusFilter === 'inactive') {
    return null;
  }

  if (changeUser?.is_sso_auth) {
    return null;
  }

  if (myUser?.is_sso_auth) {
    return null;
  }

  return (
    <div
      className='management__table-delete'
      onClick={() => {
        setConfirmStatus(true);
        closeDropdown();
      }}
    >
      <ToggleOffIcon color={'#999999'} />
      <span>{t('managementRow.actions.deactivateUser')}</span>
    </div>
  );
};

export const SetUserRegionButton = ({myUser, changeUser, setSetRegion, closeDropdown}) => {
  const {t} = useTranslation();
  
  if (!myUser?.is_corporate && !myUser?.is_global) {
    return null;
  }

  if (changeUser.role_code !== 'regional_corporate') {
    return null;
  }

  if (!changeUser.corporate_id) {
    return null;
  }

  return (
    <div 
      className='management__table-edit' 
      onClick={() => {
        setSetRegion(true);
        closeDropdown();
      }}
    >
      <Pencil color={'#999999'} />
      <span>{t('managementRow.actions.setRegion')}</span>
    </div>
  );
};
